import { showGlobalToast } from '../components/toast/toastBus';

const CONNECTIVITY_TOAST_RATE_LIMIT_MS = 10_000;
const CONNECTIVITY_TOAST_MESSAGE = 'Connection issue — please try again.';

let lastConnectivityToastAtMs = 0;

export function canShowConnectivityToast(
  nowMs,
  lastShownAtMs,
  minIntervalMs = CONNECTIVITY_TOAST_RATE_LIMIT_MS
) {
  return nowMs - lastShownAtMs >= minIntervalMs;
}

export function resetConnectivityToastRateLimit() {
  lastConnectivityToastAtMs = 0;
}

export function notifyConnectivityIssue(nowMs = Date.now()) {
  if (!canShowConnectivityToast(nowMs, lastConnectivityToastAtMs)) {
    return false;
  }
  lastConnectivityToastAtMs = nowMs;
  showGlobalToast(CONNECTIVITY_TOAST_MESSAGE);
  return true;
}
